const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export const apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiBaseUrl}${normalizedPath}`;
}

